<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <div class="login-locale-switcher">
          <b-dropdown right variant="link" toggle-class="p-0" no-caret>
            <template #button-content>
              <img
                :src="
                  (localeOptions.find((o) => o.value === $i18n.locale) || {})
                    .flagImg
                "
                class="login-lang-flag"
                :alt="$i18n.locale"
              />
            </template>
            <b-dropdown-item
              v-for="option in localeOptions"
              :key="option.value"
              @click="changeLoginLocale(option.value)"
              class="d-flex align-items-center"
            >
              <img
                :src="option.flagImg"
                class="login-lang-flag mr-50"
                :alt="option.value"
              />
              <span>{{ option.label }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <b-link class="brand-logo">
          <img src="../assets/images/logo/logo.png" alt="logo" width="75" />
          <img
            src="../assets/images/logo/logop2.png"
            class="mt-2 ml-1"
            alt="logo"
            height="35"
          />
        </b-link>

        <b-card-title class="mb-1">
          {{ $t("login.welcome") }}
        </b-card-title>
        <b-card-text class="mb-2">
          {{ $t("login.instructions") }}
        </b-card-text>

        <!-- form -->
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- email -->
            <b-form-group label-for="email" :label="$t('login.loginLabel')">
              <validation-provider
                #default="{ errors }"
                name="Login"
                rules="required"
              >
                <b-form-input
                  id="login"
                  v-model="email"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  placeholder="john.doe"
                  autofocus
                />
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">{{ $t("login.passwordLabel") }}</label>
                <b-link :to="{ name: 'auth-forgot-password-v1' }">
                  <small>{{ $t("login.forgotPassword") }}</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                {{ $t("login.rememberMe") }}
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login"
            >
              {{ $t("login.submit") }}
            </b-button>
          </b-form>
        </validation-observer>

        <!-- <div class="text-center mt-2">
          <b-link
            class="text"
            style="font-size: 0.9rem; text-decoration: underline"
            @click="loginWithSso"
          >
            Entrar com SSO
          </b-link>
        </div> -->
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import env from "../config/env";

export default {
  mounted() {},
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      // validation rules
      required,
      email,
      passwordFieldType: "password",
      localeOptions: [
        {
          value: "pt",
          label: "Português",
          flagImg: require("@/assets/images/flags/br.png"),
        },
        {
          value: "en",
          label: "English",
          flagImg: require("@/assets/images/flags/en.png"),
        },
        {
          value: "es",
          label: "Español",
          flagImg: require("@/assets/images/flags/es.png"),
        },
      ],
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    // Antes de logar ainda não existe usuário autenticado pra salvar a
    // preferência no backend — só troca o idioma da tela e guarda a escolha;
    // profileUpdate (store/index.js) aplica e persiste isso assim que o
    // usuário loga.
    changeLoginLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("loginLocale", locale);
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.$loading(true);
      axios
        .post(api, {
          login: self.email,
          password: self.password,
        })
        .then((response) => {
          // Login novo: começa do zero (sessão/nó de um usuário anterior no
          // mesmo navegador não deve vazar pro próximo login) — exceto o
          // idioma escolhido nesta própria tela, que precisa sobreviver ao
          // clear pra ser aplicado/salvo em profileUpdate.
          const loginLocale = localStorage.getItem("loginLocale");
          localStorage.clear();
          if (loginLocale) localStorage.setItem("loginLocale", loginLocale);
          self.$store.commit("auth", response.data.access_token);
          if (response.data.access_nivel == 20) {
            self.$router.push({ path: "/condutor/index" });
          } else {
            self.$router.push({ path: "/select-node" });
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.$loading(false);
        });
    },
    loginWithSso() {
      const redirectUri = `${window.location.origin}/sso/callback`;
      const url =
        `${env.ssoLoginUrl}?client=${env.ssoClientSlug}` +
        `&redirect_uri=${encodeURIComponent(redirectUri)}`;
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style scoped>
.auth-inner >>> .card.mb-0 {
  position: relative;
}

.login-locale-switcher {
  position: absolute;
  top: 14px;
  right: 14px;
}

.login-lang-flag {
  width: 22px;
  height: auto;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
</style>
